import NavigationService from "@ane/core/lib/services/NavigationService";
import { WindowLocation } from "@ane/core/lib/services/WindowService";
import { ScorecardRouteUtils } from "@ane/exp-data/lib/routes/ScorecardRoute.utils";
import { containsIgnoreCase } from "@ane/core/lib/utils/CommonStringUtils";
import { XCARD_DOMAIN } from "@ane/exp-data/lib/constants/LinkConstants";
var AlertStates = /* @__PURE__ */ ((AlertStates2) => {
  AlertStates2[AlertStates2["active"] = 1] = "active";
  return AlertStates2;
})(AlertStates || {});
class AlertUtils {
  parseOperationChecks(expId, op) {
    let result = {
      operationAlertDictionary: {},
      error: "",
      experimentId: expId
    };
    if (!op || !op.operationCheckDictionary || !!op.error) {
      result.error = op.error;
      return result;
    }
    const inputDict = op.operationCheckDictionary;
    const operations = Object.keys(inputDict);
    operations.forEach((operationName) => {
      result.operationAlertDictionary[operationName] = {
        isDisabled: inputDict[operationName].IsDisabled,
        blockers: inputDict[operationName].Gates
      };
    });
    return result;
  }
  parseExperimentJournal(expId, expJournalResult) {
    let result = {
      error: expJournalResult.error,
      experimentJournal: {
        jounalEntries: []
      },
      experimentId: expId
    };
    if (!!expJournalResult.error || !expJournalResult.results || expJournalResult.results.length === 0) {
      return result;
    }
    const entries = expJournalResult.results.map((j) => {
      let entry = {
        changingUser: j.ChangingUser || "",
        entity: j.Entity || "",
        entryComment: j.EntryComment || "",
        eventType: j.EventType || "",
        entryTime: !!j.EntryTime ? new Date(j.EntryTime) : /* @__PURE__ */ new Date()
      };
      return entry;
    });
    return {
      error: expJournalResult.error,
      experimentJournal: {
        jounalEntries: entries
      },
      experimentId: expId
    };
  }
  getOperationMessages(operationAlertDictionary, applicableOperations) {
    if (!operationAlertDictionary) {
      return [];
    }
    applicableOperations = applicableOperations || [];
    const results = [];
    Object.keys(operationAlertDictionary).forEach((key) => {
      let value = operationAlertDictionary[key];
      if (containsIgnoreCase(applicableOperations, key)) {
        results.push(
          ...value.blockers.map((g) => {
            return g.Message + " " + (!!g.MoreInfoHtml ? g.MoreInfoHtml : "");
          })
        );
      }
    });
    return results;
  }
  parseQualityAlerts(qualityAlertsDTO) {
    if (!qualityAlertsDTO || !!qualityAlertsDTO.error || !qualityAlertsDTO.result) {
      return {
        result: {
          pendingShutdownTime: void 0,
          qualityAlerts: []
        },
        error: !!qualityAlertsDTO ? qualityAlertsDTO.error : "Quality Alerts DTO is null",
        id: qualityAlertsDTO.id
      };
    }
    const pendingShutdownTime = !!qualityAlertsDTO.result.PendingShutdownTime ? new Date(qualityAlertsDTO.result.PendingShutdownTime) : void 0;
    const qualityAlerts = [];
    if (!qualityAlertsDTO.result.Alerts) {
      return {
        error: "",
        result: {
          pendingShutdownTime,
          qualityAlerts
        },
        id: qualityAlertsDTO.id
      };
    }
    qualityAlertsDTO.result.Alerts.forEach((alertDTO) => {
      alertDTO.Alerts.forEach((stepAlertDTO) => {
        if (/active/i.test(stepAlertDTO.State)) {
          const parsed = this.parseStepAlertDTO(stepAlertDTO);
          if (!!parsed) {
            qualityAlerts.push(parsed);
          }
        }
      });
    });
    return {
      error: "",
      result: {
        pendingShutdownTime,
        qualityAlerts
      },
      id: qualityAlertsDTO.id
    };
  }
  parseStepAlertDTO(stepAlertDTO) {
    if (!this.isValidStepAlertDTO(stepAlertDTO)) {
      return void 0;
    }
    return {
      alertId: stepAlertDTO.Id,
      alertDescription: stepAlertDTO.Description,
      alertPriority: stepAlertDTO.Priority,
      alertType: stepAlertDTO.AlertType,
      evidence: this.parseEvidenceListDTO(stepAlertDTO.Evidence) || []
    };
  }
  parseEvidenceListDTO(evidenceListDTO) {
    if (!evidenceListDTO || evidenceListDTO.length === 0) {
      return [];
    }
    const scorecardAlertInfos = [];
    evidenceListDTO.forEach((e) => {
      const parsed = this.parseEvidenceDTO(e);
      if (!!parsed) {
        scorecardAlertInfos.push(parsed);
      }
    });
    return scorecardAlertInfos;
  }
  parseEvidenceDTO(evidenceDTO) {
    if (!this.isValidEvidenceDTO(evidenceDTO)) {
      return void 0;
    }
    return {
      treatment: evidenceDTO.FlightComparison.TreatmentFlight,
      control: evidenceDTO.FlightComparison.ControlFlight,
      warningType: evidenceDTO.WarningType,
      segments: evidenceDTO.FlightComparison.FilterSet.map((f) => f.Value),
      delta: evidenceDTO.RelativeDelta ? evidenceDTO.RelativeDelta * 100 : 0,
      pVal: evidenceDTO.Confidence,
      treatmentCount: evidenceDTO.TreatmentSamples,
      controlCount: evidenceDTO.ControlSamples,
      treatmentAllocation: evidenceDTO.TreatmentAllocation,
      controlAllocation: evidenceDTO.ControlAllocation,
      scorecardLink: evidenceDTO.DetailsUrl,
      scorecardText: "Scorecard (" + evidenceDTO.FlightComparison.AnalysisPeriod.Start + " - " + evidenceDTO.FlightComparison.AnalysisPeriod.End + ")"
    };
  }
  isValidStepAlertDTO(stepAlertDTO) {
    return !!stepAlertDTO && !!stepAlertDTO.Evidence;
  }
  isValidEvidenceDTO(evidenceDTO) {
    return !!evidenceDTO && !!evidenceDTO.FlightComparison && !!evidenceDTO.FlightComparison.FilterSet && !!evidenceDTO.FlightComparison.AnalysisPeriod && !!evidenceDTO.WarningType;
  }
  parseQualityAlertsVNext(qualityAlertsDTO) {
    if (!qualityAlertsDTO || !!qualityAlertsDTO.error || !qualityAlertsDTO.result) {
      return {
        result: {
          pendingShutdownTime: void 0,
          qualityAlerts: []
        },
        error: !!qualityAlertsDTO ? qualityAlertsDTO.error : "Quality Alerts DTO is null",
        id: qualityAlertsDTO.id
      };
    }
    const pendingShutdownTime = !!qualityAlertsDTO.result.PendingShutdownTime ? new Date(qualityAlertsDTO.result.PendingShutdownTime) : void 0;
    const qualityAlerts = [];
    if (!qualityAlertsDTO.result.Alerts) {
      return {
        error: "",
        result: {
          pendingShutdownTime,
          qualityAlerts
        },
        id: qualityAlertsDTO.id
      };
    }
    qualityAlertsDTO.result.Alerts.forEach((alertDTO) => {
      alertDTO.Alerts.forEach((stepAlertDTO) => {
        if (1 == stepAlertDTO.state) {
          const parsed = this.parseStepAlertDTOVNext(stepAlertDTO);
          if (!!parsed) {
            qualityAlerts.push(parsed);
          }
        }
      });
    });
    return {
      error: "",
      result: {
        pendingShutdownTime,
        qualityAlerts
      },
      id: qualityAlertsDTO.id
    };
  }
  parseStepAlertDTOVNext(stepAlertDTO) {
    if (!this.isValidStepAlertDTOVNext(stepAlertDTO)) {
      return void 0;
    }
    return {
      alertId: stepAlertDTO.id,
      alertDescription: stepAlertDTO.description,
      alertPriority: stepAlertDTO.priority,
      alertType: stepAlertDTO.alertType,
      evidence: this.parseEvidenceListDTOVNext(stepAlertDTO.evidence) || []
    };
  }
  parseEvidenceListDTOVNext(evidenceListDTO) {
    if (!evidenceListDTO || evidenceListDTO.length === 0) {
      return [];
    }
    const scorecardAlertInfos = [];
    evidenceListDTO.forEach((e) => {
      const parsed = this.parseEvidenceDTOVNext(e);
      if (!!parsed) {
        scorecardAlertInfos.push(parsed);
      }
    });
    return scorecardAlertInfos;
  }
  parseEvidenceDTOVNext(evidenceDTO) {
    var _a, _b, _c, _d, _e, _f;
    if (!this.isValidEvidenceDTOVNext(evidenceDTO)) {
      return void 0;
    }
    return {
      treatment: evidenceDTO.variantComparison.treatmentVariant,
      control: evidenceDTO.variantComparison.controlVariant,
      warningType: evidenceDTO.warningType,
      segments: evidenceDTO.variantComparison.filterSet.map((f) => f.value),
      delta: ((_a = evidenceDTO == null ? void 0 : evidenceDTO.metricWarningData) == null ? void 0 : _a.relativeDelta) ? ((_b = evidenceDTO == null ? void 0 : evidenceDTO.metricWarningData) == null ? void 0 : _b.relativeDelta) * 100 : 0,
      pVal: evidenceDTO.confidence,
      treatmentCount: (_c = evidenceDTO == null ? void 0 : evidenceDTO.srmWarningData) == null ? void 0 : _c.treatmentSamples,
      controlCount: (_d = evidenceDTO == null ? void 0 : evidenceDTO.srmWarningData) == null ? void 0 : _d.controlSamples,
      treatmentAllocation: (_e = evidenceDTO == null ? void 0 : evidenceDTO.srmWarningData) == null ? void 0 : _e.treatmentAllocation,
      controlAllocation: (_f = evidenceDTO == null ? void 0 : evidenceDTO.srmWarningData) == null ? void 0 : _f.controlAllocation,
      scorecardLink: this.BuildxCardUrl(
        evidenceDTO.experimentStepId,
        evidenceDTO.variantComparison.scorecardId,
        this.buildSegment(evidenceDTO.variantComparison.filterSet),
        evidenceDTO.variantComparison.controlVariant,
        evidenceDTO.variantComparison.treatmentVariant
      ),
      scorecardText: "Scorecard (" + evidenceDTO.variantComparison.analysisPeriod.startDateTime + " - " + evidenceDTO.variantComparison.analysisPeriod.endDateTime + ")"
    };
  }
  BuildxCardUrl(stepId, scorecardId, segment, control, treatment) {
    let xCardUrl = `${XCARD_DOMAIN}`;
    xCardUrl = `${WindowLocation.origin}${ScorecardRouteUtils.routes.root.url()}`;
    let paramsList = [];
    this.addParams(paramsList, "stepId", stepId);
    this.addParams(paramsList, "scorecardIds", scorecardId == null ? void 0 : scorecardId.toString());
    this.addParams(paramsList, "segments", segment);
    this.addParams(paramsList, "control", control);
    this.addParams(paramsList, "treatment", treatment);
    paramsList.forEach((param, index) => index === 0 ? xCardUrl += `?${param}` : xCardUrl += `&${param}`);
    xCardUrl = NavigationService.getCustomQueryParams(xCardUrl, WindowLocation.search);
    return xCardUrl;
  }
  addParams(paramsList, name, value) {
    if (value) {
      paramsList.push(`${name}=${value}`);
    }
  }
  buildSegment(filterSet) {
    const AggregateSegment = "**NONE**";
    const AggregateSegmentType = "Aggregate";
    let segmentDimensions = [];
    filterSet == null ? void 0 : filterSet.forEach((dimension) => {
      segmentDimensions.push(AggregateSegment !== dimension.name ? `${dimension.name}:${dimension.value}` : AggregateSegmentType);
    });
    return segmentDimensions.toString();
  }
  isValidStepAlertDTOVNext(stepAlertDTO) {
    return !!stepAlertDTO && !!stepAlertDTO.evidence;
  }
  isValidEvidenceDTOVNext(evidenceDTO) {
    return !!evidenceDTO && !!evidenceDTO.variantComparison && !!evidenceDTO.variantComparison.filterSet && !!evidenceDTO.variantComparison.analysisPeriod && !!evidenceDTO.warningType;
  }
  createResolveAlertRequestDTO(alertEngageData) {
    return {
      AlertIds: alertEngageData.alertIds || [],
      AlertEngagement: {
        EngagementDateTime: (/* @__PURE__ */ new Date()).toISOString(),
        Comment: !!alertEngageData.alertEngagement ? alertEngageData.alertEngagement.comment || "" : "",
        EngagementReason: {
          Name: !!alertEngageData.alertEngagement ? alertEngageData.alertEngagement.engagementReason.name || "" : "",
          DisplayName: !!alertEngageData.alertEngagement ? alertEngageData.alertEngagement.engagementReason.displayName || "" : ""
        }
      }
    };
  }
}
const AlertUtils$1 = new AlertUtils();
export {
  AlertStates,
  AlertUtils,
  AlertUtils$1 as default
};
//# sourceMappingURL=AlertUtils.js.map
